import type { FitmentFieldDefinition } from "../models/FitmentCatalog";
import { normalizeFitmentKey } from "./fitmentFields";

// Examples only: previewing a draft never requests or changes merchant records.
export const getFieldSampleValues = (field: FitmentFieldDefinition): string[] => {
    const key = normalizeFitmentKey(field);
    let values: string[];
    if (field.dataType === "Date") values = ["2024-01-15", "2024-06-20", "2025-03-10"];
    else if (field.dataType === "Decimal") values = ["1.5", "2.5", "10.5"];
    else if (key === "year") values = ["2022", "2023", "2024", "2025"];
    else if (key === "make") values = ["Honda", "Kawasaki", "Suzuki", "Yamaha"];
    else if (key === "model") values = ["Model 2", "Model 10", "Model 125"];
    else if (key === "region_market" || /region|market/i.test(field.label)) values = ["Canada", "Europe", "United States"];
    else if (field.dataType === "Number" || /engine|displacement|\bcc\b/i.test(field.label)) values = ["125", "250", "600", "1000"];
    else values = ["Option 1", "Option 2", "Option 10"];

    const numeric = field.dataType === "Number" || field.dataType === "Decimal"
        || (field.sortMode ?? "NaturalNumeric") === "NaturalNumeric";
    const direction = (field.sortDirection ?? (key === "year" ? "Desc" : "Asc")) === "Desc" ? -1 : 1;
    return values.sort((a, b) => a.localeCompare(b, "en", { numeric, sensitivity: "base" }) * direction);
};

